import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { ExternalLink, TrendingUp, Users, Zap } from 'lucide-react';

export default function AffiliateAnalyticsDashboard({ clientId }) {
  return (
    <div className="space-y-6">
      {/* Ultra Affiliate Banner */}
      <div
        data-testid="ultra-affiliate-banner"
        className="relative overflow-hidden rounded-xl p-6"
        style={{
          background: 'linear-gradient(135deg, #1e1b4b 0%, #4c1d95 50%, #7c3aed 100%)',
        }}
      >
        <div className="relative z-10">
          <div className="flex items-center gap-2 mb-2">
            <Zap className="h-5 w-5 text-amber-400" />
            <span className="text-amber-400 font-bold text-sm tracking-wider uppercase">Ultra Partner Program</span>
          </div>
          <h3 className="text-white text-xl font-bold mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Put Your Partner Program on STEROIDS
          </h3>
          <p className="text-purple-200 text-sm mb-4 max-w-lg" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            Become an Ultra Partner — promote 3 brands, earn 3x commissions, one dashboard. 
            Cross-brand referrals mean more revenue from the same network.
          </p>
          <div className="flex flex-wrap gap-3 mb-4">
            <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5">
              <Users className="h-3.5 w-3.5 text-purple-300" />
              <span className="text-white text-xs font-medium">3 Brands</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5">
              <TrendingUp className="h-3.5 w-3.5 text-green-300" />
              <span className="text-white text-xs font-medium">3x Commissions</span>
            </div>
            <div className="flex items-center gap-1.5 bg-white/10 backdrop-blur-sm rounded-lg px-3 py-1.5">
              <Zap className="h-3.5 w-3.5 text-amber-300" />
              <span className="text-white text-xs font-medium">1 Dashboard</span>
            </div>
          </div>
          <a
            href="https://web-techservices.com/ultra-affiliate"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="ultra-affiliate-learn-more-btn"
            className="inline-flex items-center gap-2 text-white font-bold text-sm px-6 py-2.5 rounded-lg transition-all hover:scale-105"
            style={{
              background: 'linear-gradient(135deg, #3b82f6, #8b5cf6, #f97316)',
            }}
          >
            Learn More <ExternalLink className="h-4 w-4" />
          </a>
        </div>
        {/* Decorative circles */}
        <div className="absolute -top-8 -right-8 w-32 h-32 rounded-full bg-white/5" />
        <div className="absolute -bottom-6 -left-6 w-24 h-24 rounded-full bg-white/5" />
      </div>

      {/* Regular Dashboard Content */}
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <CardTitle className="text-lg font-semibold" style={{ fontFamily: "'Outfit', sans-serif" }}>
              Partner Analytics Dashboard
            </CardTitle>
            <Badge variant="outline">Coming Soon</Badge>
          </div>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-slate-500" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            This module is being configured. Check back soon for detailed analytics on your partner performance.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
